export const SEGMENT_EVENTS = {
  LCB_VISIT: 'LCB visit',
  SATISFACTION_THUMBS_UP: 'search satisfaction thumbs up',
  SATISFACTION_THUMBS_DOWN: 'search satisfaction thumbs down',
  SATISFACTION_DISMISS: 'search satisfaction dismiss',
}

export const LIST_ROW_THRESHOLD = 8

export const THUMB_COLORS = {
  upActive: '#52c41a',
  downActive: '#ff4d4f',
  inactive: '#2f4151',
  border: '#bbbbbb',
}

export const SEGMENT_ATTACH_USER_CONFIG = { attachUserData: true }

const getGlobalDismissStorageKey = (kid) =>
  `author:searchSatisfaction:globalDismiss:${kid || ''}`

export const isSearchSatisfactionGloballyDismissed = (kid) => {
  if (!kid) return false
  return sessionStorage.getItem(getGlobalDismissStorageKey(kid)) === '1'
}

export const setSearchSatisfactionGloballyDismissed = (kid) => {
  if (!kid) return
  sessionStorage.setItem(getGlobalDismissStorageKey(kid), '1')
}

export const buildSatisfactionSegmentPayload = ({
  libraryType,
  surface,
  searchId,
  filter = {},
  items = [],
  threshold,
}) => {
  const searchString = filter?.searchString || []
  const resultIdsAboveBanner = items
    .slice(0, threshold)
    .map((item) => item?._id)
    .filter(Boolean)

  return {
    libraryType,
    surface,
    searchId: searchId || '',
    sessionId: window.sessionStorage?.kid || '',
    searchString,
    filter,
    resultIdsAboveBanner,
  }
}

export const getGridCountInARow = (windowWidth) => {
  if (windowWidth > 1600) return 5
  if (windowWidth >= 1366) return 4
  return 3
}

export const getInsertThreshold = (viewMode, gridCountInARow) =>
  viewMode === 'tile' ? 2 * gridCountInARow : LIST_ROW_THRESHOLD
